
    import {computed, defineComponent, reactive, toRefs} from 'vue'

    interface State {
        blueCircleWidth: number;
    }

    export default defineComponent({
        name: "nevsCard",
        props: {
            progress: Number,
            currentGradient: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            strokeWidth: {
              type: [Number, String],
              default: 8
            },
            circleId: String
        },
        setup(props: any) {
            let state: State = reactive({
                blueCircleWidth: 0,
            })
            const strokeWidthRender = computed<number | string>(() => props.strokeWidth)
            const progressRender = computed<number | string>(() => props.progress);
            const circumference = computed(() => 2 * Math.PI * 45);
            const dashOffset = computed(() => {
              return circumference.value - (props.progress / 100) * circumference.value;
            });
            return {
                state,
                circumference,
                strokeWidthRender,
                dashOffset,
                progressRender,
                ...toRefs(props),
            }
        },
    })
